import { toPlainTextSync } from '@wix/ricos';
const getVideoUrl = () => '';
const getVideoEmbeddedUrl = () => '';
const getAudioUrl = () => '';
const getGifUrl = () => '';
export function toPlainText(content) {
  return toPlainTextSync(content, {
    addLinksToText: false,
    getVideoUrl,
    getVideoEmbeddedUrl,
    getAudioUrl,
    getGifUrl
  });
}
export function isRichContent(data) {
  return typeof data === 'object' && data !== null && data.hasOwnProperty('nodes');
}
//# sourceMappingURL=rich-content.js.map